module.exports = __webpack_public_path__ + "static/media/17.00d6d4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/17.png
// module id = 383
// module chunks = 0